import { useTranslate } from '@refinedev/core';
import { Tag, Tooltip, theme } from 'antd';

/** The hero CTA is hardcoded to "listen", so a slot without playable audio
 * is broken in the app — advisory only, the save still goes through. */
export const HeroAudioRequiredTag = () => {
  const t = useTranslate();
  const { token } = theme.useToken();

  return (
    <Tooltip title={t('user_catalog.home_page.hero.audio_required_hint')}>
      <Tag
        style={{
          marginInlineEnd: 0,
          background: token.colorBgContainer,
          borderColor: token.colorBorder,
          color: token.colorTextSecondary,
        }}
      >
        <span
          style={{
            color: token.colorError,
            marginInlineEnd: token.marginXXS,
            fontSize: token.fontSizeSM - 3,
          }}
        >
          ●
        </span>
        {t('user_catalog.home_page.hero.audio_required')}
      </Tag>
    </Tooltip>
  );
};
